var m = require('mithril');
var prop = require('mithril/stream');
var Model = require('../../libs/Model');
var base = require('../../../../../models/rest/restHttp');
var helpers = require('./formHelpers');

var restHttp = Object.assign(Object.create(base), Model);

restHttp.fields = base.fields;
restHttp.extrawidth = true;

var initForm = restHttp.initForm;

var YES_NO_DEFAULT = [
  { name: 'Default', value: '' },
  { name: 'Yes', value: 'true' },
  { name: 'No', value: 'false' }
];

var HTTP_DOCS_URL = '/docs/configuration/http';

var RESPONSE_FORMATS = [
  { name: 'JSON', value: 'json' },
  { name: 'XML', value: 'xml' },
  { name: 'HTML', value: 'html' },
  { name: 'Text', value: 'text' },
  { name: 'Auto', value: 'auto' }
];

function authTypeValue() {
  var configured = String(restHttp.form.authType() || '').toLowerCase();
  if (configured === 'session') return 'none';
  if (configured) return configured;
  if (restHttp.form.bearerToken()) return 'bearer';
  if (sessionLoginEnabled()) return 'none';
  if (restHttp.form.username()) return 'basic';
  return 'none';
}

function sessionLoginEnabled() {
  return Boolean(Number(restHttp.form.useSession()));
}

function hasFormValue(key) {
  return restHttp.form[key] && String(restHttp.form[key]() || '').trim();
}

function hasAuthenticationOptions() {
  return Boolean(
    sessionLoginEnabled() ||
    authTypeValue() !== 'none' ||
    hasFormValue('username') ||
    hasFormValue('password') ||
    hasFormValue('bearerToken') ||
    hasFormValue('preAuthUrl') ||
    hasFormValue('authUrl') ||
    hasFormValue('nameField') ||
    hasFormValue('passField') ||
    String(restHttp.form.authMethod() || '').toLowerCase() !== 'get'
  );
}

function hasResponseOptions() {
  var format = String(restHttp.form.responseFormat() || '').trim().toLowerCase();
  return Boolean(
    (format && format !== 'json') ||
    Number(restHttp.form.html()) ||
    Number(restHttp.form.xml()) ||
    hasFormValue('gzip')
  );
}

function setAuthType(value) {
  restHttp.form.authType(value === 'none' ? '' : value);
}

function setSessionLogin(enabled) {
  restHttp.form.useSession(enabled ? 1 : 0);
  if (enabled) restHttp.form.authType('');
}

restHttp.modalTitle = function (titleText) {
  return m('span.flex.items-center', [
    m('span', titleText),
    m('a.white.f3.ml2.pointer.no-underline', {
      href: HTTP_DOCS_URL,
      target: '_blank',
      rel: 'noopener noreferrer',
      title: 'Open HTTP configuration docs',
      'aria-label': 'Open HTTP configuration docs',
      onclick: function (ev) {
        if (ev) ev.stopPropagation();
      }
    }, [
      m('i.ion-ios-help-outline')
    ])
  ]);
};

function addHeaderPair(rows, name, value) {
  if (!name && !value) return;
  if (Array.isArray(value)) {
    value.forEach(function (entry) {
      rows.push({ name: String(name || ''), value: entry == null ? '' : String(entry) });
    });
    return;
  }
  rows.push({ name: String(name || ''), value: value == null ? '' : String(value) });
}

function parseHeaderRows(value) {
  var raw = value || '';
  var rows = [];
  var parsed;

  if (typeof raw === 'object' && !Array.isArray(raw)) {
    Object.keys(raw).forEach(function (key) {
      addHeaderPair(rows, key, raw[key]);
    });
    return rows.length ? rows : [{ name: '', value: '' }];
  }

  raw = String(raw).trim();
  if (!raw) return [{ name: '', value: '' }];

  if (raw[0] === '{') {
    try {
      parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        Object.keys(parsed).forEach(function (key) {
          addHeaderPair(rows, key, parsed[key]);
        });
        return rows.length ? rows : [{ name: '', value: '' }];
      }
    } catch (e) {}
  }

  raw.split(/[\n&]/).forEach(function (line) {
    var separator;
    var name;
    var headerValue;
    line = line.trim();
    if (!line) return;
    separator = line.indexOf(':') > -1 ? ':' : '=';
    if (line.indexOf(separator) === -1) return;
    name = line.slice(0, line.indexOf(separator)).trim();
    headerValue = line.slice(line.indexOf(separator) + 1).trim();
    if (!name && !headerValue) return;
    try {
      name = decodeURIComponent(name.replace(/\+/g, ' '));
      headerValue = decodeURIComponent(headerValue.replace(/\+/g, ' '));
    } catch (e) {}
    rows.push({ name: name, value: headerValue });
  });

  return rows.length ? rows : [{ name: '', value: '' }];
}

function hasHeaderRows(rows) {
  return (rows || []).some(function (row) {
    return row && (String(row.name || '').trim() || String(row.value || '').trim());
  });
}

function serializeHeaderRows(rows) {
  return (rows || [])
  .filter(function (row) {
    return row && String(row.name || '').trim();
  })
  .map(function (row) {
    return String(row.name || '').trim() + ': ' + (row.value == null ? '' : String(row.value).trim());
  })
  .join('\n');
}

function setHeaderRows(rows) {
  restHttp.headerRows(rows);
  restHttp.form.headers(serializeHeaderRows(rows));
}

function updateHeaderRow(index, key, value) {
  var rows = restHttp.headerRows().slice();
  rows[index] = Object.assign({}, rows[index] || {}, { [key]: value });
  setHeaderRows(rows);
}

function addHeaderRow() {
  setHeaderRows(restHttp.headerRows().concat([{ name: '', value: '' }]));
}

function removeHeaderRow(index) {
  var rows = restHttp.headerRows().slice();
  rows.splice(index, 1);
  setHeaderRows(rows.length ? rows : [{ name: '', value: '' }]);
}

function renderHeadersEditor(index) {
  return helpers.collapsibleSection({
    title: 'Headers',
    isOpen: restHttp.headersSectionOpen,
    toggle: function () { toggleSection(restHttp.headersSectionOpen); },
    index: index,
    content: [
      m('div.mb2', restHttp.headerRows().map(function (row, index) {
        var nameId = 'resthttp-header-name-' + index;
        var valueId = 'resthttp-header-value-' + index;
        return m('div.flex.items-end.mb2', { key: index, style: { gap: '0.75rem' } }, [
          m('div.flex-auto', { style: { minWidth: '12rem' } }, [
            index === 0 ? m('label', { for: nameId }, 'Name') : null,
            m('input.form-control', {
              id: nameId,
              autocomplete: 'off',
              spellcheck: false,
              autocorrect: 'off',
              placeholder: 'Header name',
              value: row.name,
              oninput: function (ev) { updateHeaderRow(index, 'name', ev.target.value); }
            })
          ]),
          m('div.flex-auto', { style: { minWidth: '12rem' } }, [
            index === 0 ? m('label', { for: valueId }, 'Value') : null,
            m('input.form-control', {
              id: valueId,
              autocomplete: 'off',
              spellcheck: false,
              autocorrect: 'off',
              placeholder: 'Header value',
              value: row.value,
              oninput: function (ev) { updateHeaderRow(index, 'value', ev.target.value); }
            })
          ]),
          m('button.f4.ba.br2.bg-transparent.blue.pointer.flex.items-center.justify-center', {
            type: 'button',
            title: 'Remove header',
            'aria-label': 'Remove header',
            style: {
              height: '2.5em',
              minHeight: '2.5em',
              width: '2.5em',
              padding: 0
            },
            onclick: function () { removeHeaderRow(index); }
          }, [
            m('i.ion-ios-trash')
          ])
        ]);
      })),
      m('button.f5.ba.br2.bg-transparent.blue.pointer.ph2.pv1', {
        type: 'button',
        onclick: addHeaderRow
      }, [
        m('i.ion-plus.mr1'),
        'Add header'
      ])
    ]
  });
}

function renderCredentialFields(usernameHelp, passwordHelp) {
  return helpers.columns([
    helpers.text(restHttp, 'username', 'Username', usernameHelp),
    helpers.text(restHttp, 'password', 'Password', passwordHelp, { type: 'password' })
  ]);
}

function renderAuthenticationOptions(useSessionLogin, authType, index) {
  var usesRequestCredentials = authType === 'basic' || authType === 'digest';
  var sessionCredentialHelp = usesRequestCredentials
    ? 'Used for session login and Basic/Digest request auth.'
    : 'Used for session login.';

  return helpers.collapsibleSection({
    title: 'Authentication',
    isOpen: restHttp.authenticationSectionOpen,
    toggle: function () { toggleSection(restHttp.authenticationSectionOpen); },
    index: index,
    content: [
      helpers.select(restHttp, 'authType', 'Request auth', [
        { name: 'None', value: 'none' },
        { name: 'Basic', value: 'basic' },
        { name: 'Digest', value: 'digest' },
        { name: 'Bearer token', value: 'bearer' }
      ], 'Choose the credential type sent with each request.', {
        value: function () { return authType; },
        onchange: function (ev) { setAuthType(ev.target.value); }
      }),
      helpers.switchField('Use session login', 'Log in first, store cookies, and reuse them until they expire.', function () {
        return useSessionLogin;
      }, function (enabled) {
        setSessionLogin(enabled);
      }),
      usesRequestCredentials && !useSessionLogin
        ? renderCredentialFields('Sent with Basic/Digest request auth.', 'Sent with Basic/Digest request auth.')
        : null,
      authType === 'bearer' ? helpers.text(restHttp, 'bearerToken', 'Bearer token', 'Sent as an Authorization header when bearer auth is selected.') : null,
      useSessionLogin ? helpers.section('Session Login Details', [
        helpers.columns([
          helpers.select(restHttp, 'authMethod', 'Login method', [
            { name: 'GET', value: 'get' },
            { name: 'POST', value: 'post' }
          ], 'HTTP method used for the login request.'),
          helpers.text(restHttp, 'preAuthUrl', 'Pre-auth URL', 'Optional URL requested before login to seed CSRF/session cookies.')
        ]),
        helpers.text(restHttp, 'authUrl', 'Login URL', 'Path appended to the base URL for session login.'),
        renderCredentialFields(sessionCredentialHelp, sessionCredentialHelp),
        helpers.columns([
          helpers.text(restHttp, 'nameField', 'Username field', 'JSON field name sent in the login body. Default: username.'),
          helpers.text(restHttp, 'passField', 'Password field', 'JSON field name sent in the login body. Default: password.')
        ])
      ]) : null
    ]
  });
}

function hasTransportOptions() {
  return Boolean(restHttp.form.followRedirect() || restHttp.form.strictSSL() || restHttp.form.proxy());
}

function hasAdvancedOptions() {
  return Boolean(restHttp.form.requestOptions());
}

function toggleSection(section) {
  section(!section());
}

function renderHttpOptions(startIndex) {
  return [
    helpers.collapsibleSection({
      title: 'Response',
      isOpen: restHttp.responseSectionOpen,
      toggle: function () { toggleSection(restHttp.responseSectionOpen); },
      index: startIndex,
      content: helpers.columns([
        helpers.select(restHttp, 'responseFormat', 'Response format', RESPONSE_FORMATS, 'Default parser for resources that do not override it.', {
          value: function () { return helpers.responseFormatValue(restHttp.form); },
          onchange: function (ev) { helpers.setResponseFormat(restHttp.form, ev.target.value); }
        }),
        helpers.select(restHttp, 'gzip', 'Gzip', YES_NO_DEFAULT, 'Enable when the server returns compressed responses.')
      ])
    }),
    helpers.collapsibleSection({
      title: 'Transport',
      isOpen: restHttp.transportSectionOpen,
      toggle: function () { toggleSection(restHttp.transportSectionOpen); },
      index: startIndex + 1,
      content: [
        helpers.columns([
          helpers.select(restHttp, 'followRedirect', 'Follow redirects', YES_NO_DEFAULT, 'Leave Default to use the standard HTTP behavior.'),
          helpers.select(restHttp, 'strictSSL', 'Certificate validation', [
            { name: 'Default', value: '' },
            { name: 'Validate certificates', value: 'true' },
            { name: 'Allow self-signed', value: 'false' }
          ], 'Default preserves the existing self-signed certificate behavior for RestHTTP requests.')
        ]),
        helpers.text(restHttp, 'proxy', 'Proxy URL', 'Optional proxy URL for outbound requests.')
      ]
    }),
    helpers.collapsibleSection({
      title: 'Advanced',
      isOpen: restHttp.advancedSectionOpen,
      toggle: function () { toggleSection(restHttp.advancedSectionOpen); },
      index: startIndex + 2,
      content: helpers.textarea(restHttp, 'requestOptions', 'Request options JSON', 'Merged into request-promise options for library settings not exposed above.', { tall: true })
    })
  ];
}

restHttp.initForm = function (record, options) {
  initForm.call(restHttp, record, options);
  if (String(restHttp.form.authType() || '').toLowerCase() === 'session') {
    restHttp.form.authType('');
    restHttp.form.useSession(1);
  }
  restHttp.responseSectionOpen = prop(hasResponseOptions());
  restHttp.transportSectionOpen = prop(hasTransportOptions());
  restHttp.advancedSectionOpen = prop(hasAdvancedOptions());
  restHttp.headerRows = prop(parseHeaderRows(restHttp.form.headers()));
  restHttp.headersSectionOpen = prop(hasHeaderRows(restHttp.headerRows()));
  restHttp.authenticationSectionOpen = prop(hasAuthenticationOptions());
};

restHttp.initForm();

restHttp.view = function () {
  var useSessionLogin = sessionLoginEnabled();
  var authType = authTypeValue();

  return m('form', { role: 'form' }, [
    restHttp.errorView(),
    helpers.modelSwitch(restHttp, 'enabled', 'Enabled', 'Disabled hosts stay configured but do not poll.', 1, 0),
    helpers.section('Connection', [
      helpers.columns([
        helpers.text(restHttp, 'name', 'Name', 'Display name for the HTTP host.'),
        helpers.text(restHttp, 'host', 'Base URL', 'Scheme and host, for example https://controller.example.com.')
      ]),
      helpers.columns([
        helpers.text(restHttp, 'port', 'Port', 'Optional TCP port appended to the base URL.'),
        helpers.text(restHttp, 'apiRoot', 'API root', 'Common path prefix for every resource on this host.')
      ]),
      helpers.text(restHttp, 'timeout', 'Timeout ms', 'HTTP request timeout for poll and write calls. Defaults to 10000 ms when blank.')
    ]),
    renderAuthenticationOptions(useSessionLogin, authType, 0),
    renderHeadersEditor(1),
    renderHttpOptions(2)
  ]);
};

module.exports = restHttp;
